var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);
import getIP from "../getIP.js";
const IP = getIP();
import { useQuery } from "react-query";
import { getGlobalConfigNoAuth } from "../lib/login-api.js";
import { lightenColor } from "utils/colors.utils.js";
import { lazy, Suspense } from "react";
const loadChildThemeProvider = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { ThemeProvider: ChildThemeProvider } = yield import("adrinWebApp/ThemeContext");
        console.log("Loaded child ThemeProvider:", ChildThemeProvider);
        return ChildThemeProvider;
    }
    catch (error) {
        console.error("Error loading ThemeProvider from child app:", error);
        return null;
    }
});
export const ThemeProvider = ({ children }) => {
    const [ChildThemeProvider, setChildThemeProvider] = useState(null);
    useEffect(() => {
        loadChildThemeProvider().then((Provider) => {
            if (Provider) {
                console.log("Child ThemeProvider loaded successfully");
                setChildThemeProvider(() => Provider);
            }
        });
    }, []);
    const { data: configData, isLoading: isAuthConfigLoading } = useQuery(["noAuthConfig"], getGlobalConfigNoAuth, {
        onError: (err) => {
            console.log("error while getting config no auth: ", err);
        },
    });
    const [theme, setTheme] = useState({
        font: "Nunito",
        logos: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
        loginLogo: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
        enableLoginLogo: "Enable",
        primaryColor: "#E00800",
        secondaryColor: "#353ef2",
        tertiaryColor: "#777578",
        sideMenuColor: "#2d2e42",
        backgroundColor: "#f5f5fa",
        tncUrl: ``,
        policyUrl: ``,
        backgroundImageLandingPage: `${IP}/static/media/comviva-background.18edf10ea57d4ea52fba.jpg`,
        announcementText: "Hello, Brand Setting page is being defined.........",
        announcementUrl: IP,
        announcementFlag: "Disable",
        faviconUrl: `${IP}/favicon.ico`,
        menuTextColor: "#FFFFFF",
        menuTextColorOnHover: "#ED1C24",
        radioCheckboxColor: "#353ef2",
        enablePolicy: "Disable",
        enableTerms: "Disable",
        selectedLanguages: [
            {
                title: "English",
                code: "en",
            },
        ],
        enableSignUp: "Enable",
        footer: "All rights reserved.",
        display: "",
        dateFormat: "dd/MM/yyyy",
        timeFormat: "HH:mm:ss",
        url: "",
        disableForgotPasswordFlow: "Enable",
        // primaryColor: "#4B0F1E",
        // secondaryColor: "#E00800",
        // fontFamily: "SuisseIntl",
        // tertiaryColor: "#232323",
        // sideMenuColor: "#4B0F1E",
        // backgroundColor: "white",
        // Add more theme properties as needed
    });
    // useEffect(()=>{
    //   sessionStorage.setItem('theme', JSON.stringify(theme));
    // },[])
    const { refetch } = useQuery(["getBrandList"], fetchColorsFromApi, {
        enabled: !isAuthConfigLoading,
        onSuccess: (data) => {
            var _a, _b, _c, _d, _e, _f;
            if (data) {
                let defaultSettings = {
                    font: "Nunito",
                    logos: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
                    loginLogo: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
                    enableLoginLogo: "Enable",
                    primaryColor: "#E00800",
                    secondaryColor: "#353ef2",
                    tertiaryColor: "#777578",
                    sideMenuColor: "#2d2e42",
                    backgroundColor: "#f5f5fa",
                    radioCheckboxColor: "#353ef2",
                    tncUrl: ``,
                    policyUrl: ``,
                    backgroundImageLandingPage: `${IP}/static/media/comviva-background.18edf10ea57d4ea52fba.jpg`,
                    announcementText: "Hello, Brand Setting page is being defined.........",
                    announcementUrl: IP,
                    announcementFlag: "Disable",
                    faviconUrl: `${IP}/favicon.ico`,
                    menuTextColor: "#FFFFFF",
                    menuTextColorOnHover: "#ED1C24",
                    enablePolicy: "Disable",
                    enableTerms: "Disable",
                    selectedLanguages: [
                        {
                            title: "English",
                            code: "en",
                        },
                    ],
                    enableSignUp: "Enable",
                    footer: "All rights reserved.",
                    display: "",
                    dateFormat: "MM-DD-YYYY",
                    timeFormat: "HH:mm:ss",
                    url: "",
                    disableForgotPasswordFlow: "Enable",
                    version: "v8.3.0",
                };
                let color = ((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.brandSettingJson) || defaultSettings;
                document.body.style.backgroundColor = color.backgroundColor;
                let bflag = ((_c = configData === null || configData === void 0 ? void 0 : configData.find((e) => e.key === "bflag")) === null || _c === void 0 ? void 0 : _c.value) || "false";
                let defaultStyle = ((_d = configData === null || configData === void 0 ? void 0 : configData.find((e) => e.key === "defaultStyleFlag")) === null || _d === void 0 ? void 0 : _d.value) ||
                    "true";
                let enableBackgroundLogo = ((_e = configData === null || configData === void 0 ? void 0 : configData.find((e) => e.key === "enableBackgroundLogo")) === null || _e === void 0 ? void 0 : _e.value) ||
                    "true";
                let flags = {};
                flags.bflag = bflag;
                flags.defaultStyle = defaultStyle;
                flags.enableBackgroundLogo = enableBackgroundLogo;
                const linkElement = document.querySelector("link[rel*='icon']") ||
                    document.createElement("link");
                linkElement.type = "image/png";
                linkElement.rel = "icon";
                linkElement.href = color.faviconUrl;
                document.title =
                    color.enableLabel === "true" ? color.labelName : "Ngage";
                document.head.appendChild(linkElement);
                const themeValue = Object.assign(Object.assign(Object.assign({}, defaultSettings), color), flags);
                setTheme(themeValue);
                document.documentElement.style.setProperty("--button-radius", ".375rem");
                // document.documentElement.style.setProperty("--button-radius", "9999px");
                document.documentElement.style.setProperty("--primaryColor", themeValue.primaryColor);
                document.documentElement.style.setProperty("--secondaryColor", themeValue.secondaryColor);
                document.documentElement.style.setProperty("--tertiaryColor", themeValue.tertiaryColor);
                document.documentElement.style.setProperty("--backgroundColor", themeValue.backgroundColor);
                if (themeValue.font === "Nunito") {
                    document.documentElement.style.setProperty("--table-content-font-weight", 600);
                    document.documentElement.style.setProperty("--button-font-weight", 700);
                }
                const isScrollbarEnabled = ((_f = configData === null || configData === void 0 ? void 0 : configData.find((e) => e.key === "isScrollbarEnabled")) === null || _f === void 0 ? void 0 : _f.value) ||
                    "false";
                if (String(isScrollbarEnabled) === "true") {
                    const scrollbarColor = lightenColor(color.primaryColor, 0.5);
                    const scrollbarHoverColor = lightenColor(color.primaryColor, 0.2);
                    // document.documentElement.style.setProperty(
                    //   "--scrollbarColor",
                    //   scrollbarColor
                    // );
                    // document.documentElement.style.setProperty(
                    //   "--scrollbarHoverColor",
                    //   scrollbarHoverColor
                    // );
                    document.documentElement.classList.add("show-scrollbar");
                }
                else {
                    document.documentElement.classList.remove("show-scrollbar");
                }
                sessionStorage.setItem("theme", JSON.stringify(Object.assign(Object.assign(Object.assign({}, defaultSettings), color), flags)));
                window.dispatchEvent(new Event('themeUpdated'));
                setIsThemeLoading(false);
            }
            else {
                let res = sessionStorage.getItem("theme");
                if (!res) {
                    sessionStorage.setItem("theme", JSON.stringify(theme));
                }
                else {
                    setTheme(JSON.parse(res));
                }
                setIsThemeLoading(false);
            }
        },
        onError: () => {
            let res = sessionStorage.getItem("theme");
            if (!res) {
                sessionStorage.setItem("theme", JSON.stringify(theme));
            }
            else {
                setTheme(JSON.parse(res));
            }
            setIsThemeLoading(false);
        },
    });
    const [isThemeLoading, setIsThemeLoading] = useState(true);
    const content = (_jsx(ThemeContext.Provider, { value: {
            theme,
            setTheme,
            isThemeLoading,
            isAuthConfigLoading,
            refetch,
            formatDatePickerDate: (dateFormatStr, timeFormatStr) => {
                var _a;
                try {
                    const formattedDate = (_a = dateFormatStr === null || dateFormatStr === void 0 ? void 0 : dateFormatStr.replace(/D/g, "d")) === null || _a === void 0 ? void 0 : _a.replace(/Y/g, "y");
                    console.log(`[INFO] received format ${dateFormatStr} ${timeFormatStr}\nFormatted date: ${formattedDate} ${timeFormatStr}`);
                    return (formattedDate +
                        (timeFormatStr ? " " + timeFormatStr.replace("A", "aa") : ""));
                }
                catch (error) {
                    console.error("Error parsing date format string:", error);
                    return dateFormatStr; // or handle the error as needed
                }
            },
        }, children: children }));
    // If child ThemeProvider is loaded, wrap with it
    if (ChildThemeProvider) {
        return _jsx(ChildThemeProvider, { children: content });
    }
    return content;
};
function fetchColorsFromApi() {
    return __awaiter(this, void 0, void 0, function* () {
        const IP = getIP();
        const response = yield axios(`${IP}` + "/api/v1/config/brand");
        return response === null || response === void 0 ? void 0 : response.data;
        // Assuming the API returns an object with color values
    });
}
export default ThemeProvider;
